// MessagesList.js
import React from 'react'
import useChats from '../util/hooks/useChats'
import PropTypes from 'prop-types'
import { List, ListItem, ListItemText, ListItemButton, CircularProgress, Alert, Typography, Divider, Box, IconButton, Tooltip, ListItemIcon } from '@mui/material'
import CreateIcon from '@mui/icons-material/Create'
import ChatIcon from '@mui/icons-material/Chat'

const ChatsList = ({ onSelectChat, chatId }) => {
  const { chats, loading, error } = useChats()

  if (loading) {
    return <CircularProgress />
  }

  if (error) {
    return <Alert severity="error">Error loading chats: {error.message}</Alert>
  }

  return (
    <>
    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', pl: 1 }}>
      <Typography variant='h5' align='center'>Chats</Typography>
      <Tooltip title={'New Chat'}>
        <IconButton size='large' onClick={() => onSelectChat(null)}>
          <CreateIcon />
        </IconButton>
      </Tooltip>
    </Box>
      <Divider></Divider>
      {chats.length === 0
        ? (
        <Alert severity="info">No chats found.</Alert>
          )
        : (
        <List dense={true} sx={{ overflow: 'auto' }}>
          {chats.map((chat) => (
            <ListItem key={chat.id} onClick={() => onSelectChat(chat.id)}>
              <ListItemButton selected={chat.id === chatId}>
                <ListItemIcon>
                  <ChatIcon></ChatIcon>
                </ListItemIcon>
                <ListItemText primary={chat.label + '...'} secondary={'Updated at: ' + chat.updatedAt?.toDate().toLocaleDateString()}/>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
          )}
    </>
  )
}

ChatsList.propTypes = {
  onSelectChat: PropTypes.func.isRequired,
  chatId: PropTypes.string
}

export default ChatsList
